const formatterCache = new Map();

const getFormatter = (locale = 'en-GB', currency = 'GBP') => {
  const key = `${locale}|${currency}`;
  if (!formatterCache.has(key)) {
    formatterCache.set(
      key,
      new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    );
  }
  return formatterCache.get(key);
};

export const roundMoney2 = (value) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return null;
  return Math.round((num + Number.EPSILON) * 100) / 100;
};

export const formatMoney = (value, { locale = 'en-GB', currency = 'GBP', fallback = '—' } = {}) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return fallback;
  const rounded = roundMoney2(num);
  if (!Number.isFinite(rounded)) return fallback;
  return getFormatter(locale, currency).format(rounded);
};

export const formatMoneyPlain = (value, { fallback = '' } = {}) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return fallback;
  const rounded = roundMoney2(num);
  if (!Number.isFinite(rounded)) return fallback;
  return rounded.toFixed(2);
};

export default {
  roundMoney2,
  formatMoney,
  formatMoneyPlain,
};
